import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  DatePicker,
  Button,
  Select,
  Table,
  InputNumber,
  Popconfirm,
  message,
  Card,
  Upload,
} from "antd";
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import moment from "moment";
import config from "../../util/ApiforContext";
import { useLocation } from "react-router-dom";

const OrderDeliveryUpdateForm = (props) => {
  const [form] = Form.useForm();
  const [orderSelect, setOrderSelect] = useState({
    data: [],
    loading: false,
  });
  const [orderItems, setOrderItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get("mode") || "edit"; // default edit
  const isViewMode = mode === "view";

  useEffect(() => {
    if (props.data) {
      const data = props.data;

      RequestHandler.post(
        `/OrderDelivery/GetFiles/${data?.id}`,
        {},
        false,
        {}
      ).then((response) => {
        if (response.success) {
          setExistingFiles(response.data);
        } else {
          setExistingFiles([]);
        }
      });

      form.setFieldsValue({
        deliveryNumber: data?.deliveryNumber,
        description: data?.description,
        deliveryDate: data?.deliveryDate ? moment(data?.deliveryDate) : null,
        orderId: data?.orderId,
        id: data?.id,
      });
      setOrderItems(
        props.data.orderDeliveryItems.map((item) => ({
          key: item.id,
          id: item.id,
          stockId: item.stockId,
          name: item.name,
          stockCode: item.stockCode,
          orderQuantity: item.orderQuantity,
          quantity: item.quantity,
        }))
      );
      getOrderData(data?.orderId);
    }
  }, [props.data]);

  const handleOrderChange = (orderId) => {
    const selectedOrder = orderSelect.data.find((o) => o.id === orderId);
    if (selectedOrder) {
      setOrderItems(
        selectedOrder.orderItems.map((item) => ({
          key: item.id,
          id: item.id,
          stockId: item.stockId,
          name: item.name,
          stockCode: item.stockCode,
          orderQuantity: item.quantity,
          deliveryQuantity: null,
        }))
      );
    } else {
      setOrderItems([]);
    }
  };

  const handleDelete = (key) => {
    setOrderItems((prev) => prev.filter((item) => item.key !== key));
  };

  const columns = [
    {
      title: "Malzeme Adı",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "Malzeme Kodu",
      dataIndex: "stockCode",
      key: "stockCode",
      align: "center",
    },
    {
      title: "Sipariş Miktarı",
      dataIndex: "orderQuantity",
      key: "orderQuantity",
      align: "center",
    },
    {
      title: "Teslimat Miktarı",
      dataIndex: "quantity",
      key: "quantity",
      align: "center",
      width: "25%",
      render: (_, record) => (
        <InputNumber
          className="ant-input"
          style={{ width: "100%" }}
          decimalSeparator=","
          thousandSeparator="."
          precision={0}
          min={0}
          max={record.orderQuantity}
          defaultValue={record.quantity}
          onChange={(val) => {
            setOrderItems((prev) =>
              prev.map((item) =>
                item.key === record.key ? { ...item, quantity: val } : item
              )
            );
          }}
        />
      ),
    },
    {
      title: "Sil",
      key: "action",
      width: 60,
      render: (_, record) => (
        <Button
          danger
          type="link"
          icon={<DeleteOutlined />}
          onClick={() => handleDelete(record.key)}
        ></Button>
      ),
    },
  ];

  const onFinish = async () => {
    setLoading(true);
    const values = await form.validateFields();
    const payload = {
      documentVms: existingFiles,
      deliveryNumber: values.deliveryNumber,
      deliveryDate: values.deliveryDate
        ? values.deliveryDate.format("YYYY-MM-DD")
        : null,
      description: values.description,
      orderId: values.orderId,
      id: values.id,
      orderDeliveryItemUpdateDtos: orderItems
        .filter((i) => i.quantity !== null && i.quantity > 0)
        .map((i) => ({
          quantity: i.quantity,
          stockId: i.stockId,
          orderDeliveryId: values.orderId,
          id: i.id,
        })),
    };

    const formData = new FormData();
    formData.append("jsonString", JSON.stringify(payload));
    // Files alanı: her dosyayı ayrı ayrı 'Files' olarak append et
    files.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    RequestHandler.put(
      `/OrderDelivery`,
      formData,
      true,
      {},
      "multipart/form-data"
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        props.onSuccess();
      }
    });
    setLoading(false);
  };

  const getOrderData = (orderId) => {
    RequestHandler.get(`/Order/GetById/${orderId}`).then((response) => {
      if (response) {
        const data = response;
        //#region

        setOrderSelect({ data: [data], loading: false });
      } else {
        message.error("Sipariş verileri alınamadı.");
      }
    });
  };

  const onOrderSearch = (value) => {
    if (value.length >= 2) {
      setOrderSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Order?$select=id,name,description&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("description", value)})`
      ).then((res) => {
        setOrderSelect({ data: res.value, loading: false });
      });
    } else {
      setOrderSelect({ data: [], loading: false });
    }
  };

  const fileDownload = (file) => {
    window.open(
      `${config.apiUrl}/FileDownload/${file}?t=${RequestHandler.getToken()}`
    );
  };

  return (
    <Form layout="vertical" form={form}>
      <Form.Item name="id" hidden></Form.Item>
      <Form.Item label="Sipariş :" name="orderId">
        <Select
          allowClear
          showSearch
          placeholder="En az 2 harf giriniz.."
          onSearch={onOrderSearch}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
            option.code
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
          loading={orderSelect.loading}
          disabled={props?.data && props?.data?.orderId} // Disable if orderId is passed as prop
          onChange={handleOrderChange}
        >
          {orderSelect.data.map((item) => (
            <Select.Option
              key={item.id}
              value={item.id}
              description={item.description}
            >
              {item.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="Teslimat Numarası :"
        name="deliveryNumber"
        rules={[{ required: true, message: "Teslimat numarası gerekli" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item label="Teslimat Tarihi :" name="deliveryDate">
        <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item label="Açıklama :" name="description">
        <Input.TextArea rows={3} />
      </Form.Item>

      <Table
        dataSource={orderItems}
        columns={columns}
        pagination={false}
        rowKey="key"
        style={{ marginTop: 16 }}
        scroll={{ x: true }}
      />

      <Card
        title={
          <span style={{ fontWeight: "bold", fontSize: 18 }}>Dosyalar</span>
        }
        bordered={false}
        style={{ marginTop: 16 }}
      >
        {/* API'den gelen dosyalar */}
        {existingFiles.length > 0 && (
          <div style={{ marginBottom: 16 }}>
            {existingFiles.map((file) => (
              <div
                key={file.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: "1px solid #ddd",
                  padding: "8px 12px",
                  marginBottom: 8,
                  borderRadius: 4,
                }}
              >
                <span>{file.fileName.split("\\").pop()}</span>
                <div>
                  <Button
                    type="link"
                    onClick={() => fileDownload(file.fileName)}
                  >
                    İndir
                  </Button>
                  <Button
                    type="link"
                    danger
                    onClick={() =>
                      setExistingFiles((prev) =>
                        prev.filter((f) => f.id !== file.id)
                      )
                    }
                    hidden={isViewMode}
                  >
                    Sil
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Yeni dosya yükleme alanı */}
        <Upload
          multiple
          beforeUpload={() => false}
          onChange={({ fileList }) => setFiles(fileList)}
          fileList={files}
        >
          <Button icon={<UploadOutlined />}>Dosya Yükle</Button>
        </Upload>
      </Card>

      <div style={{ marginTop: 16, textAlign: "right" }}>
        <Button onClick={props.onCancel} style={{ marginRight: 8 }}>
          İptal
        </Button>
        <Button type="primary" onClick={onFinish} loading={loading}>
          Güncelle
        </Button>
      </div>
    </Form>
  );
};

export default OrderDeliveryUpdateForm;
